import { StoreFamily } from '@services/StoreService'
import { CountMetric, EnvironmentDetail } from '@amzn/ihm-associate-tools-js-lib'
import { AssociateToolsBaseCapabilities, isCapabilityAvailable } from '@services/Core/AssociateToolsBaseCapabilityAvailabilityService'
import { getStoreInfo } from '@atredux/selectors/storeSelector'
import { store } from '@atredux/store'

// GetScheduledPendingContent must be called within 15 seconds after provision
const FIND_SURVEYS_DELAY_AFTER_PROVISION_SECONDS = 15

const CONNECTIONS_STORE_FAMILY_ALLOWLIST = [
    StoreFamily.IHM,
    StoreFamily.MENDEL,
    StoreFamily.KASPIAN,
    StoreFamily.HOUDINI,
]

let calledConnectionsForSurvey
let timerPromise

/**
 * Connections survey is disabled — all JWO customers are now 3P and
 * Connections is a 1P-only feature. Returning false unconditionally
 * prevents the notAvailableCount metric from being emitted (P433684315).
 */
export const isConnectionsEnabled = () => {
    return false
}

/**
 * Starts a countdown timer of 15 seconds and records a metric based on whether Connections was called successfully
 */
export const startCountdown = () => {
    calledConnectionsForSurvey = false
    timerPromise = setTimeout(() => {
        console.info(`ATBase: ${FIND_SURVEYS_DELAY_AFTER_PROVISION_SECONDS} seconds passed. Publishing metric`)
        timerPromise = undefined
        recordMetric()
    }, FIND_SURVEYS_DELAY_AFTER_PROVISION_SECONDS * 1000)
}

/**
 * Acknowledges that the Connections content was received and sets the calledConnectionsForSurvey flag to true
 */
export const connectionsCalled = () => {
    console.info('ATBase: Has called Connections to GetScheduledPendingContent')
    calledConnectionsForSurvey = true
}

const recordMetric = () => {
    const metric = new CountMetric(EnvironmentDetail.getStoreId(), 'Fault', 'IhmFlyingDutchman', 'NotCalledConnectionsService')
    if (calledConnectionsForSurvey) {
        console.info(`ATBase: Has called Connections to GetScheduledPendingContent within ${FIND_SURVEYS_DELAY_AFTER_PROVISION_SECONDS} seconds, publishing metric`)
        metric.count(0)
    } else {
        console.info(`ATBase: Did not call Connections to GetScheduledPendingContent within ${FIND_SURVEYS_DELAY_AFTER_PROVISION_SECONDS} seconds, publishing metric for a fault`)
        metric.count(1)
    }
}
